export const isString = (val: any) => {
  if (val.includes(".")) {
    return true;
  }
  if (val.length === 1 && val === " ") {
    return false;
  }
  if (
    val[val.length - 1] === " " &&
    val[val.length - 1] !== val[val.length - 2]
  ) {
    return true;
  }
  if (
    val[val.length - 1]?.trim()?.toLowerCase() !==
    val[val.length - 1]?.trim()?.toUpperCase() ||
    val === ""
  ) {
    return true;
  }
  return false;
};
export const isNumberWithDot = (val: any) => {
  if (val[val.length - 1] === " ") {
    return false;
  }
  // if (val.includes(".")) {
  //   return false;
  // }
  // eslint-disable-next-line no-restricted-globals
  if (!isNaN(val?.trim()) || val === "") {
    return true;
  }
  return false;
};
export const isFloat = (val: any) => {
  if (val[val.length - 1] === " " || val === "." || val === "0") {
    return false;
  }
  if (val.includes(".")) {
    val = val.replace(".", "");
    // eslint-disable-next-line no-restricted-globals
    if ((!val.includes(".") && !isNaN(val?.trim())) || val === "") {
      return true;
    }
    return false;
  }
  // eslint-disable-next-line no-restricted-globals
  if (!isNaN(val?.trim()) || val === "") {
    return true;
  }
  return false;
};
export const isNumber = (val: any) => {
  if (val[val.length - 1] === " ") {
    return false;
  }
  // if (val.includes(".")) {
  //   return false;
  // }
  // eslint-disable-next-line no-restricted-globals
  if (!isNaN(val?.trim()) || val === "") {
    return true;
  }
  return false;
};
export const isNumberPrice = (value: any) => {
  const regex = /^(?!.*\..*\.)[0-9]*(\.[0-9]{0,2})?$/;

  return regex.test(value);
};

export const isValidInput = (value: string) => {
  if (value === "") {
    return true;
  }
  if (value.trim() === "") {
    return false; // Reject if the value is empty or only consists of whitespace
  }

  if (value.includes("  ") || value.includes("..")) {
    return false; // Reject if there are consecutive spaces or decimals
  }

  return true; // Accept the input if it meets all the conditions
};


export const formattedDescriptionText = (text: string) => {
  if (!text) return '';

  // Replace newlines with <br/>
  text = text.replace(/\n+/g, '<br/><br/>');

  // Convert text enclosed in ** to bold
  text = text.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');

  // Convert URLs into clickable links without adding spaces
  text = text.replace(/(https?:\/\/[^\s]+|www\.[^\s]+)/g, (match) => {
    // Remove unwanted prefixes like <br/><br/>- or any accidental formatting
    let cleanedMatch = match.replace(/<br\/?><br\/?>-?\s?/g, '');
    let url = cleanedMatch.startsWith('www.') ? `https://${cleanedMatch}` : cleanedMatch;
    return `<a href="${url}" target="_blank">${cleanedMatch}</a>`;
  });

  // Convert email addresses into clickable mailto links without adding spaces
  text = text.replace(/\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,7}\b/g, (match) => {
    return `<a href="mailto:${match}">${match}</a>`;
  });

  // Prevent breaking "sq.ft" and similar patterns by keeping them together
  text = text.replace(/\b(\d+\s?sq\.ft)\b/g, '<span style="white-space: nowrap;">$1</span>');


  let sentences = text.split(/([.!?]\s)/g); // Split by punctuation followed by space to retain structure
  let formattedText = '';

  for (let sentence of sentences) {
    if (sentence.trim() === '') continue;

    let words = sentence.split(' ');
    for (let i = 0; i < words.length; i++) {
      let word = words[i];

      // Add line breaks before and after colons
      if (word.endsWith(':')) {
        formattedText += `${word}` + ' ';
      }
      // Ensure bullet points start on a new line
      else if (word === '-' || word === 'O') {
        formattedText += `<br/>- `;
      }
      // Prevent breaking words that are naturally hyphenated (e.g., built-in, en-suite)
      else if (word.startsWith('-') && words[i - 1] !== '<br/>') {
        formattedText += `<br/>${word} `;
      }
      // Prevent adding extra space in hyperlinks and emails
      else if (word.includes('<a href') || word.includes('white-space: nowrap;')) {
        formattedText += word;
      }
      // Regular words
      else {
        formattedText += word + ' ';
      }
    }
  }

  return formattedText.trim();
};